// src/hooks/useDynamicFontLoader.js
import {useEffect} from 'react';

const useDynamicFontLoader = () => {
  const path = 'assets/fonts';
  const ext = '.ttf';
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fontFiles = [
    {
      family: 'Poppins',
      name: 'Poppins-Light',
      weight: 300,
    },
    {
      family: 'Poppins',
      name: 'Poppins-Regular',
      weight: 400,
    },
    {
      family: 'Poppins',
      name: 'Poppins-Medium',
      weight: 500,
    },
    {
      family: 'Poppins',
      name: 'Poppins-SemiBold',
      weight: 600,
    },
    {
      family: 'Poppins',
      name: 'Poppins-Bold',
      weight: 700,
    },
    {
      family: 'Roboto',
      name: 'Roboto-Bold',
      weight: 700,
    },
  ];

  useEffect(() => {
    fontFiles.forEach(font => {
      const fontUrl = `${path}/${font.name}${ext}`;
      const style = document.createElement('style');
      style.appendChild(
        document.createTextNode(`
          @font-face {
            font-family: '${font.family}';
            src: local('${font.name}'), url('${fontUrl}') format('truetype');
            font-weight: ${font.weight};
            font-display: swap;
          }
        `),
      );
      document.head.appendChild(style);
    });
  }, [fontFiles]);
};

export default useDynamicFontLoader;
